export function formatNumber(
  value: number,
  language: string,
  options?: Intl.NumberFormatOptions,
): string {
  const locale = language === "ar" ? "ar-EH" : "en-US";
  return value.toLocaleString(locale, options);
}

const mediumDateFormatters: Record<string, Intl.DateTimeFormat> = {};

export function formatDateMedium(iso: string, language: string): string {
  const locale = language === "ar" ? "ar-EH" : "en-US";
  const formatter = (mediumDateFormatters[locale] ??= new Intl.DateTimeFormat(
    locale,
    { dateStyle: "medium" },
  ));
  return formatter.format(new Date(iso));
}

export function pluralizeAr(
  n: number,
  one: string,
  two: string,
  plural: string,
  many?: string,
): string {
  if (n === 1) return one;
  if (n === 2) return two;
  if (n >= 3 && n <= 10) return `${n} ${plural}`;
  return `${n} ${many ?? one}`;
}

export function pluralizeEn(
  n: number,
  singular: string,
  plural: string,
): string {
  return n === 1 ? `1 ${singular}` : `${n} ${plural}`;
}

export function formatCredits(n: number, language: string): string {
  return language === "ar"
    ? pluralizeAr(n, "رصيد واحد", "رصيدان", "أرصدة", "رصيدًا")
    : pluralizeEn(n, "credit", "credits");
}

export function formatDurationFull(minutes: number, language: string): string {
  if (minutes <= 0) return "";

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  const isArabic = language === "ar";

  const hourText = isArabic
    ? pluralizeAr(hours, "ساعة", "ساعتين", "ساعات")
    : pluralizeEn(hours, "hour", "hours");

  const minuteText = isArabic
    ? pluralizeAr(remainingMinutes, "دقيقة", "دقيقتين", "دقائق")
    : pluralizeEn(remainingMinutes, "minute", "minutes");

  if (hours === 0) return minuteText;
  if (remainingMinutes === 0) return hourText;

  return `${hourText} ${isArabic ? "و" : "and"} ${minuteText}`;
}
